// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Avatar, Box, SpeedDial, SpeedDialAction, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import {
    EmojiEvents, HowToVote, MenuBook, MonetizationOn, MusicNote, School, SportsTennis, Whatshot, YouTube,
} from '@mui/icons-material';

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component

const SpeedDialFocus = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component SpeedDialFocus Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define Imperative Handle

    // TODO: Define variable
    const [opened, setOpened] = React.useState(true);

    const actions = [
        {
            Title: { CHI: '2026 中學文憑試成績', ENG: '2026 中學文憑試成績', },
            Icon: <EmojiEvents />,
            URL: 'https://www.pohtyh.edu.hk/ACH_DSEResult2026',
        },
        {
            Title: { CHI: '2026 DSE優秀學生訪問', ENG: '2026 DSE優秀學生訪問', },
            Icon: <School />,
            URL: 'https://www.pohtyh.edu.hk/DSEOutstandingStudentVisit',
        },
        {
            Title: { CHI: '「法團校董會家長校董選舉」結果公佈', ENG: '「法團校董會家長校董選舉」結果公佈' },
            Icon: <HowToVote />,
            URL: 'https://www.pohtyh.edu.hk/Files/Home/20260320「法團校董會家長校董選舉」結果公佈.pdf',
        },
        {
            Title: { CHI: '中一學位申請', ENG: '中一學位申請' },
            Icon: <HowToVote />,
            URL: 'https://www.pohtyh.edu.hk/ADM_S1Registration',
            EndDate: '2026-01-17',
        },
        {
            Title: { CHI: '音樂比賽2025-2026', ENG: 'Music Contest 2025-2026' },
            Icon: <MusicNote />,
            URL: 'https://www.pohtyh.edu.hk/MusicContest',
            EndDate: '2026-01-23',
        },
        {
            Avatar: 'https://www.pohtyh.edu.hk/Files/Album/20260428/thumbs/20260428_01.jpg',
            Title: {
                CHI: 'F.3 Choral Speaking: We Placed & Won!',
                ENG: 'F.3 Choral Speaking: We Placed & Won!',
            },
            URL: '/Album?ID=20260428',
        },
        {
            Avatar: 'https://www.pohtyh.edu.hk/Files/Album/20251124/thumbs/R6M29845.JPG',
            Title: { CHI: '男子甲組排球學界錦標賽冠軍', ENG: '男子甲組排球學界錦標賽冠軍', },
            URL: '/Album?ID=20251124',
        },
        {
            Title: { CHI: '博愛醫院董事局全力支持立法會換屆選舉宣傳短片', ENG: '博愛醫院董事局全力支持立法會換屆選舉宣傳短片' },
            Icon: <YouTube />,
            URL: 'https://www.youtube.com/watch?v=PuTSbL-vk4w',
            EndDate: '2025-12-07',
        },
        {
            Title: { CHI: '第二十四屆家長教師會執行委員會委員選舉結果公布', ENG: '第二十四屆家長教師會執行委員會委員選舉結果公布' },
            Icon: <HowToVote />,
            URL: 'https://www.pohtyh.edu.hk/Album?ID=20251103',
            EndDate: '2025-11-11 17:00:00',
        },
        {
            Title: {CHI: '學校專訪：<br>「浮才、育才、揚才」的課程特色' },
            Icon: <MenuBook />,
            URL: '/P202505191128',
        },
        {
            Title: { CHI: '第十七屆「法團校董會家長校董選舉」結果', ENG: '第十七屆「法團校董會家長校董選舉」結果' },
            Icon: <HowToVote />,
            URL: 'https://www.pohtyh.edu.hk/Album?ID=20250313',
            EndDate: '2025-03-21',
        },
        {
            Icon: <SportsTennis />,
            Title: { CHI: '師生投入匹克球活動 走在國際最前線', ENG: '師生投入匹克球活動 走在國際最前線', },
            URL: '/P202501240736',
        },
        {
            Avatar: 'https://www.pohtyh.edu.hk/Files/Album/20240524/Slide.jpg',
            Title: { CHI: '天主教聖安德肋小學<br/>Live In The Moment音樂會', ENG: '天主教聖安德肋小學<br/>Live In The Moment音樂會', },
            URL: 'https://www.pohtyh.edu.hk/Album?ID=20240524',
            EndDate: '2024-07-12',
        },
        {
            Avatar: 'https://www.pohtyh.edu.hk/Files/Album/2024LWLF4/Slide.jpg',
            Title: { CHI: '中四全方位喜義日', ENG: '中四全方位喜義日', },
            URL: 'https://www.pohtyh.edu.hk/Album?ID=2024LWLF4',
            EndDate: '2024-07-12',
        },
        {
            Title: { CHI: '中六級歲月如歌歌唱比賽', ENG: '中六級歲月如歌歌唱比賽' },
            Icon: <MusicNote />,
            URL: 'https://www.pohtyh.edu.hk/MusicContest',
            EndDate: '2024-11-16',
        },
        /*{
            Title: { CHI: '全港小學生兒童繪本主題曲創作大賽2024', ENG: '全港小學生兒童繪本主題曲創作大賽2024' },
            Icon: <Draw />,
            URL: 'https://www.pohtyh.edu.hk/Files/Focus/20240117_全港小學生兒童繪本主題曲創作大賽2024.pdf',
            EndDate: '2024-03-02',
        },
        {
            Title: { CHI: '校友會燒烤', ENG: '校友會燒烤' },
            Icon: <OutdoorGrill />,
            URL: 'https://www.facebook.com/events/1155110535857958?mibextid=9l3rBW',
            EndDate: '2024-03-16',
        },
        {
            Title: { CHI: '2024年度校友校董選舉', ENG: '2024年度校友校董選舉' },
            Icon: <OutdoorGrill />,
            URL: 'https://www.pohtyh.edu.hk/Files/Alumni/2024年度校友校董選舉通知.pdf',
            EndDate: '2024-03-08',
        },*/
    ];

    // TODO: Define event
    const theme = useTheme();

    const isActionActive = (endDate) => {
        if (!endDate) return true; // 沒設定則永遠顯示

        // 如果格式是 YYYY-MM-DD（只有日期），把它視為當天結束（本機時區 23:59:59.999）
        if (typeof endDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
            const [y, m, d] = endDate.split('-').map(Number);
            const endOfDay = new Date(y, m - 1, d, 23, 59, 59, 999);
            return Date.now() <= endOfDay.getTime();
        }

        // 其他情況嘗試直接解析（支援完整 ISO 字串或時間戳）
        const parsed = new Date(endDate);
        if (isNaN(parsed.getTime())) {
            // 解析失敗，保守做法：顯示該項目
            return true;
        }
        return Date.now() <= parsed.getTime();
    };

    // TODO: Return component
    return (
        <>
            <style>
                {
                    `@keyframes gradient {
                        0 % {
                            background-position: 0% 50%;
                        }
                        50% {
                            background-position: 100% 50%;
                        }
                        100% {
                            background-position: 0% 50%;
                        }
                    }`
                }
            </style>
            <SpeedDial
                ariaLabel="SpeedDial basic example"
                direction="down"
                FabProps={{
                    color: 'tertiary',
                    variant: 'extended',
                    sx: {
                        animation: 'gradient 2s ease infinite',
                        backgroundImage: `linear-gradient(90deg, ${theme.palette.tertiary.dark}, ${theme.palette.tertiary.light})`,
                        backgroundSize: '200% 200%',
                        height: '64px',
                    },
                }}
                sx={{ alignItems: 'end', position: 'fixed', top: { xs: 64, md: 24 }, right: 16 }}
                icon={
                    <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                        {<Whatshot fontSize="large" />}
                        <Typography variant="h6">{Text.Home.Focus.Title[context.language]}</Typography>
                    </Box>
                }
                open={opened}
                //onClick={() => { navigate(`/News`); } }
                onMouseEnter={() => { setOpened(true) }}
                onMouseLeave={() => { setOpened(false) }}
            >
                {
                    actions.map((action, i) => {
                        if (isActionActive(action.EndDate)) {
                            return (
                                <SpeedDialAction
                                    key={i}
                                    FabProps={{
                                        size: 'large',
                                        sx: {
                                            animation: 'gradient 2s ease infinite',
                                            backgroundImage: `linear-gradient(90deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.light})`,
                                            backgroundSize: '200% 200%',
                                            justifyContent: 'start',
                                            maxWidth: '300px',
                                            '&:hover': { backgroundColor: 'secondary.light', },
                                        },
                                        variant: 'extended'
                                    }}
                                    icon={
                                        <a
                                            style={{
                                                alignItems: 'center',
                                                color: 'black',
                                                display: 'flex',
                                                gap: 8,
                                                textDecoration: 'none',
                                            }}
                                            href={action.URL}
                                            rel="noreferrer"
                                            target="_blank"
                                        >
                                            {action.Avatar && <Avatar src={action.Avatar} />}
                                            {action.Icon && <>{action.Icon}</>}
                                            <span dangerouslySetInnerHTML={{ __html: action.Title[context.language] }}></span>
                                        </a>
                                    }
                                />
                            )
                        }
                        return false;
                    })
                }
            </SpeedDial>
        </>
    );
};

export default React.memo(SpeedDialFocus);